package com.essntl.features.request.ui.addeditrequest

import core.validation.Form
import core.validation.field.DateRangeField
import core.validation.field.Field
import core.validation.field.ListField
import core.validation.field.StringField
import core.validation.validator.DateDoubleValidator
import core.validation.validator.DateRangeValidator
import core.validation.validator.NonEmptyListValidator
import core.validation.validator.NonEmptyValidator

class AddEditRequestValidation {
    val addEditRequestForm = AddEditRequestForm()
}

class AddEditRequestForm : Form() {
    val areas =
        ListField(NonEmptyListValidator)

    val travelAgent =
        StringField(NonEmptyValidator)

    val title =
        StringField(NonEmptyValidator)

    val dateRange =
        DateRangeField(
            validators =
            arrayOf(
                DateDoubleValidator(),
                DateRangeValidator(
                    firstValueRequired = true,
                    secondValueRequired = true,
                ),
            ),
        )

    override val fields: List<Field> =
        listOf(
            areas,
            travelAgent,
            title,
            dateRange,
        )
}
